/** QC Sample Collection update (manual p109): the Sample No. link off the pending list. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { QcCollectPage } from "@/features/quality/components/collect/qc-collect-page";

export const Route = createFileRoute("/_app/quality/pending/$sampleId")({
  params: {
    parse: ({ sampleId }) => {
      if (!/^\d+$/.test(sampleId)) throw notFound();
      return { sampleId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.sample_pending"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <QcCollectPage id={Number(sampleId)} />;
}
